import React, { FC } from 'react'

import { SettingsHeaderProps } from '@/types/componentsPropsTypes'

import { Description, HeaderElem, Title } from './styles'

export const SettingsHeader: FC<SettingsHeaderProps> = ({
  title,
  description,
}) => (
  <HeaderElem>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </HeaderElem>
)
